import React, { useState } from 'react';
import { Modal, Button, Input, message } from 'antd';
import { uploadEmail } from '../../../../../core/api/settings';

const ExcelExportModal = ({ 
  visible, 
  onCancel, 
  onExport, 
  exportType = 'data',
  loading = false 
}) => {
  const [emailAddress, setEmailAddress] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    try {
      await onExport(false); // false means direct download
      onCancel();
    } catch (error) {
      console.error('Download error:', error);
    }
  };

  const handleEmailSend = async () => {
    if (!emailAddress || !emailAddress.includes('@')) {
      message.error("Please enter a valid email address");
      return;
    }
    
    setIsLoading(true);
    try {
      // Get the file from the export function
      const reportFile = await onExport(true); // true means return file
      
      const formData = new FormData();
      formData.append("attachment", reportFile, `${exportType}_Export.xlsx`);
      formData.append("to", emailAddress);
      formData.append("subject", `Exported ${exportType} Report`);
      formData.append(
        "body",
        `Hello,\n\nPlease find the exported ${exportType} Excel file attached.\n\nBest regards.`
      );

      const response = await uploadEmail(formData);

      const fileUrl = response.data.report_email.signed_attachment_url;
      const subject = encodeURIComponent(`Exported ${exportType} Report`);
      const body = encodeURIComponent(
        `Hello,\n\nPlease find the exported ${exportType} report at the following link:\n\n${fileUrl}\n\nBest regards.`
      );

      window.location.href = `mailto:${emailAddress}?subject=${subject}&body=${body}`;
      message.success('Email prepared successfully!');
      onCancel();
    } catch (error) {
      console.error("Error sending email:", error);
      message.error(`Failed to send email: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title="Export Excel"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered
    >
      <div style={{ textAlign: 'center' }}>
        <p>Do you want to download the exported file or send it via email?</p>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
          <Button 
            className="btn btn-primary w-50" 
            onClick={handleDownload}
            loading={loading}
          >
            Download 
          </Button>
          <Input
            type="email"
            placeholder="Enter email address"
            className="form-control"
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value)}
            style={{ width: "100%" }}
          />
          <Button
            className="btn btn-secondary w-50"
            onClick={handleEmailSend}
            loading={isLoading}
          >
            Share via Email
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ExcelExportModal;